var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"externalLink"},[_c('a',{attrs:{"href":_vm.src.link,"target":"_blank","rel":"nofollow noreferrer"}},[_vm._v(_vm._s(_vm.src.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }